import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '../../locales/i18n';
import ExpandableList from './ExpandableList';

class Faq extends React.Component {
  constructor(props, context) {
    super(props, context);

    const { prefix } = this.props;

    const items = [];
    let index = 0;

    while (true) { // eslint-disable-line no-constant-condition
      const qName = `${prefix}-q-${index}`;
      const aName = `${prefix}-a-${index}`;
      const q = translate(qName);
      const a = translate(aName);
      if (!q || q === qName || !a || a === aName) {
        break;
      }

      items[index] = {
        text: q,
        description: a,
      };

      index += 1;
    }

    this.state = {
      items,
    };
  }

  render() {
    const { items } = this.state;

    return (
      <ExpandableList items={items} />
    );
  }
}

Faq.propTypes = {
  prefix: PropTypes.string.isRequired,
};

export default Faq;
